import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiService } from '@shared/services/api.service';
import { NotificationApi } from '../models/notification-api.model';
import { Notification } from '../models/notification.model';
import {
  NotificationsReadUpdateApiPayload,
} from '../models/notifications-read-update-api.model';
import {
  NotificationsUnreadUpdateApiPayload,
} from '../models/notifications-unread-update-api.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationsApiService {

  static apiContext = 'notifications';

  private _apiService = inject(ApiService);

  get$(): Observable<Notification[] | null> {
    return this._apiService
               .get<NotificationApi[]>(NotificationsApiService.apiContext)
               .pipe(
                   map((items) => items
                       ? items.map((item) => new Notification(item))
                       : null),
               );
  }

  getRead$(): Observable<Notification[] | null> {
    return this._apiService
               .get<NotificationApi[]>(`${ NotificationsApiService.apiContext }/read`)
               .pipe(
                   map((items) => items
                       ? items.map((item) => new Notification(item))
                       : null),
               );
  }

  getUnread$(): Observable<Notification[] | null> {
    return this._apiService
               .get<NotificationApi[]>(`${ NotificationsApiService.apiContext }/unread`)
               .pipe(
                   map((items) => items
                       ? items.map((item) => new Notification(item))
                       : null),
               );
  }

  getById$(uuid: string): Observable<Notification | null> {
    return this._apiService
               .get<NotificationApi>(`${ NotificationsApiService.apiContext }/${ uuid }`)
               .pipe(
                   map((item) => item ? new Notification(item) : null),
               );
  }

  markRead$(
      payload: NotificationsReadUpdateApiPayload,
  ): Observable<Notification[] | null> {
    return this._apiService
               .put<NotificationApi[]>({
                 url: `${ NotificationsApiService.apiContext }/read`,
                 body: payload,
               })
               .pipe(
                   map((items) => items
                       ? items.map((item) => new Notification(item))
                       : null),
               );
  }

  markUnread$(
      payload: NotificationsUnreadUpdateApiPayload,
  ): Observable<Notification[] | null> {
    return this._apiService
               .put<NotificationApi[]>({
                 url: `${ NotificationsApiService.apiContext }/unread`,
                 body: payload,
               })
               .pipe(
                   map((items) => items
                       ? items.map((item) => new Notification(item))
                       : null),
               );
  }
}
